/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';
import { CONFIG } from "~/config";

interface ILikeResponse {
	data: {
		rawCount: number,
		count: number,
		voted: boolean,
	},
}

const URL = "/likeit/v1/likes";

export function setLike(entity: string, like: boolean): Promise<ILikeResponse> {
	return new Promise(async(resolve, reject) => {
		const response = await fetch(`${CONFIG.requestUrl}${URL}/like`, {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-Correlation-Id': uuidv4(),
			},
			credentials: 'include',
			body: JSON.stringify({
				id: entity,
				value: like,
				origin: "mapy-web",
			}),
		});

		if (response?.status === 200) {
			resolve(await response.json());
		}
		else {
			reject();
		}
	});
};
